import { Badge, Flex } from '@chakra-ui/react';
import { AngularNavLink } from '@texas/components/shared/AngularNavLink';
import { Icons } from '@texas/components/shared/Icons';
import { useTranslation } from 'react-i18next';
import { isStateActive, NavigationRouteItem } from './navigationItems';

const utilityIcons = {
  manage: Icons.CogOutline,
  files: Icons.FolderOutline,
  tasks: Icons.Note,
  productApproval: Icons.Eye,
};

interface ContextUtilityLinksProps {
  activeState: string;
  items: NavigationRouteItem[];
  metaByRoute?: Record<string, string | undefined>;
  navobj: Record<string, unknown>;
}

export function ContextUtilityLinks({
  activeState,
  items,
  metaByRoute,
  navobj,
}: ContextUtilityLinksProps) {
  const { t } = useTranslation();
  const translateLabel = (label: string) => t(label as 'navigation.manage');

  return (
    <Flex
      align="center"
      gap={1}
      minH={10}
      py={1}
      borderBottomWidth="1px"
      borderColor="navigation.utilityBorder"
    >
      {items.map((item) => {
        const active = isStateActive(activeState, item.route);
        const label = translateLabel(item.label);
        const Icon = item.icon ? utilityIcons[item.icon] : null;
        const meta = metaByRoute?.[item.route];

        return (
          <AngularNavLink
            key={item.route}
            to={item.route}
            navobj={navobj}
            aria-label={meta ? `${label}: ${meta}` : label}
            aria-current={active ? 'page' : undefined}
            title={label}
            variant={active ? 'navigationUtilityActive' : 'navigationUtility'}
          >
            {Icon ? (
              <Flex align="center" justify="center" position="relative">
                <Icon flexShrink={0} />
                {meta && <Badge variant="navigation-meta">{meta}</Badge>}
              </Flex>
            ) : (
              label
            )}
          </AngularNavLink>
        );
      })}
    </Flex>
  );
}
